import React from "react";

const footer = () => 
    <div className="app-footer">
        Copyright &copy; 2022 - <a href="https://www.martinbros.com">Martin Bros Distributing Co.</a>
    </div>

export default footer;